import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=e20f77ac&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20f77ac')) {
      api.createRecord('e20f77ac', component.options)
    } else {
      api.reload('e20f77ac', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=e20f77ac&", function () {
      api.rerender('e20f77ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l3BQf5AN0g2Q/JS/comp/ImgFallback.vue"
export default component.exports